export default __webpack_public_path__ + "static/media/webDevCareer2023.fc12e672.md";